import { React } from 'react';
import { Col, Image, Row } from 'react-bootstrap';

import horizontalDashes from "../../assets/icons/products/horizontalDashes.svg";
const HighlightBanner = props => {
    let iconSection = props.section ? require('../../assets/icons/' + props.location + '/' + props.page + '/' + props.section + '.svg') : null;

    return (
        <section className={props.noPadBottom ? 'HighlightBanner section-padding noPadBottom' : 'HighlightBanner section-padding'}>
            <div className='yellow-bar left'></div>
            <div className='yellow-bar right'></div>
            <div className={props.noPadTitle ? 'section-title container-custom mb-0' : 'section-title container-custom'}>
                <div className="title-content">
                    <figure className={props.titleBlack ? 'title-black d-none d-md-block' : "d-none d-md-block"}>
                        <Image src={iconSection} />
                    </figure>
                    <div className='title-conteiner'>
                        {/* title mobile */}
                        {props.i18n.exists(props.page + ':' + props.section + '.title3') ? <h2 className={props.titleBlack ? 'title title-black d-md-none' : 'title d-md-none'}>{props.t(props.page + ':' + props.section + '.title1') + " " + props.t(props.page + ':' + props.section + '.title2') + " " + props.t(props.page + ':' + props.section + '.title3')}</h2> : <h2 className={props.titleBlack ? 'title title-black d-md-none' : 'title d-md-none'}>{props.t(props.page + ':' + props.section + '.title1') + " " + props.t(props.page + ':' + props.section + '.title2')}</h2>}

                        {/* title desktop */}
                        <h2 className={props.titleBlack ? 'title title-black d-none d-md-flex' : 'title d-none d-md-flex'}>{props.t(props.page + ':' + props.section + '.title1')}</h2>
                        <h2 className={props.titleBlack ? 'title title-black d-none d-md-flex' : 'title d-none d-md-flex'}>{props.t(props.page + ':' + props.section + '.title2')}</h2>
                        {props.i18n.exists(props.page + ':' + props.section + '.title3') ? <h2 className={props.titleBlack ? 'title title-black d-none d-md-flex' : 'title d-none d-md-flex'}>{props.t(props.page + ':' + props.section + '.title3')}</h2> : <></>}
                    </div>
                </div>
            </div>
            <div className='content'>
                {props.children}
                <Row className='container-custom'>
                    <Col sm={12}>
                        <Row className='justify-content-end'>
                            <Col sm={4} md={3} lg={2}>
                                <div className='position-relative d-none d-md-block'>
                                    <Image fluid className='horizontal-dashes' src={horizontalDashes} />
                                </div>
                            </Col>
                        </Row>
                    </Col>
                </Row>
            </div>
        </section >
    )
}

export default HighlightBanner;